import { useCallback, useState } from "react";

import CompetitorsModal from "app/pages/benchmark-tracker/components/Report/CompetitorsModal/CompetitorsModal";
import type { CompetitorsDataTypeMap } from "app/pages/benchmark-tracker/components/Report/CompetitorsModal/type";
import type { MetricTabName } from "app/pages/benchmark-tracker/config";
import { benchmarkTrackerTracking } from "app/pages/benchmark-tracker/services/tracking";

import Metric from "../Metric/Metric";

import { metrics } from "./config";

type TabEntity = { tabName: MetricTabName };

const Tab = ({ tabName }: TabEntity) => {
    const [openedModal, setOpenedModal] = useState<null | keyof CompetitorsDataTypeMap>(null);
    const [metricOptions, setMetricOptions] = useState({ isRelative: false, isInverted: false });
    const track = benchmarkTrackerTracking.metric;

    const onOpenModal = useCallback(
        (name: keyof CompetitorsDataTypeMap) => {
            setOpenedModal(name);
            track.trackSeeAllCompetitorsOpen(name);
        },
        [track],
    );

    const onCloseModal = useCallback(() => {
        setOpenedModal(null);
    }, []);

    return (
        <>
            {openedModal ? (
                <CompetitorsModal
                    metricName={openedModal}
                    isOpen={true}
                    onClose={onCloseModal}
                    tabName={tabName}
                    {...metricOptions}
                />
            ) : null}

            {metrics[tabName].map((metricProps, index) => (
                <Metric
                    key={index}
                    onOpenModal={onOpenModal}
                    setMetricOptions={setMetricOptions}
                    {...metricProps}
                />
            ))}
        </>
    );
};

export default Tab;
